import { PolluxGridConfig } from "../../../../../components/common/pollux-grid-config/pollux-grid-config";

export const templatesGridColumns: PolluxGridConfig[] = [
  {
    title: "reportDesignerDialog.templateName",
    field: "Name"
  },
  {
    title: "reportDesignerDialog.creadtedBy",
    field: "OwnerUserAcdName"
  },
  {
    title: "reportDesignerDialog.modifiedBy",
    field: "ModifiedByUserAcdName"
  },
  {
    title: "reportDesignerDialog.createdDate",
    field: "Created",
    type: "date"
  },
  {
    title: "reportDesignerDialog.modifiedDate",
    field: "Modified",
    type: "date"
  },
  {
    title: "reportDesignerDialog.language",
    field: "LanguageId"
  }
];
